import React from 'react';
// import Sidebar from '../components/Sidebar';
// import Header from '../components/Header';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
   
    <main className="flex-1 p-4 md:p-6 overflow-y-auto bg-background">
      {children}
    </main>
  
  );
};

export default MainLayout;

